module.exports = __webpack_public_path__ + "img/product-shot_07.671553b3.jpg";